import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimeSeriesFilterDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '../abstract-form-control';
import AggregationIntervalEnum = TimeSeriesFilterDto.AggregationIntervalEnum;

export const AGGREGATION_INTERVAL_LABELS: Record<string, string> = {
  Second: 'Sekunden',
  Minute: 'Minuten',
  Hour: 'Stunden',
  Day: 'Tage',
  Week: 'Wochen',
  Month: 'Monate',
  Quarter: 'Quartale',
  Year: 'Jahre',
};

export const SELECTABLE_AGGREGATION_INTERVALS: AggregationIntervalEnum[] = [
  AggregationIntervalEnum.Minute,
  AggregationIntervalEnum.Hour,
  AggregationIntervalEnum.Day,
  AggregationIntervalEnum.Week,
  AggregationIntervalEnum.Month,
  AggregationIntervalEnum.Quarter,
  AggregationIntervalEnum.Year,
];

@Component({
  standalone: false,
  selector: 'wr-aggregation-interval-select',
  templateUrl: './aggregation-interval-select.component.html',
  styleUrls: ['./aggregation-interval-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AggregationIntervalSelectComponent),
      multi: true,
    },
  ],
})
export class AggregationIntervalSelectComponent extends AbstractFormControl<AggregationIntervalEnum> {
  protected readonly intervals = SELECTABLE_AGGREGATION_INTERVALS;
  protected readonly labels = AGGREGATION_INTERVAL_LABELS;
}
